interface TickMarkProps {
  colorCode?: string;
  width?: number;
  height?: number;
  fillColor?: string;
  strokeColor?: string;
}
export const TocIcon = ({
  width = 24,
  height = 24,
}: TickMarkProps): JSX.Element => {
  return (
    <svg
      className="inline-block"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="5"
        y1="6"
        x2="19"
        y2="6"
        stroke="#9092A3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="5"
        y1="12"
        x2="19"
        y2="12"
        stroke="#9092A3"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="5"
        y1="18"
        x2="19"
        y2="18"
        stroke="#9092A3"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
